// extracted by mini-css-extract-plugin
export default {"modal__form":"FormModal_modal__form__D-DVz"};